module.exports = __webpack_public_path__ + "static/media/pickup_notification.142e991c.svg";